import { Paper } from '@mui/material'
import { appConnectionCardSurfaceSx } from './appConnectionCardConstants.js'
import { AppConnectionCardHero } from './AppConnectionCardHero.jsx'
import { AppConnectionCardBlockCardInner } from './AppConnectionCardBlockCardInner.jsx'

export function AppConnectionCardBlockCard(props) {
  const { safeTitle, iconUrl, showConnectedChrome } = props
  const surfaceSx = showConnectedChrome
    ? appConnectionCardSurfaceSx
    : { ...appConnectionCardSurfaceSx, backgroundColor: '#ffffff', border: 'none' }
  return (
    <Paper elevation={0} sx={surfaceSx}>
      <AppConnectionCardHero
        safeTitle={safeTitle}
        iconUrl={iconUrl}
        showConnectedChrome={showConnectedChrome}
      />
      <AppConnectionCardBlockCardInner {...props} />
    </Paper>
  )
}
